<template>
  <div class="card-body" :class="clazz">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'card-body',
  props: ['clazz']
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.collapse {
  .card-body {
    padding-top: 0px;
  }
}
.collapsing {
  .card-body {
    padding-top: 0px;
  }
}
.card-body {
  padding: 18px;
  @include mq-up(md) {
    padding: 30px;
  }
  &.-link {
    padding: 20px;
    @include mq-up(md){
      background-image: url('../../assets/images/icons/arrow-right-orange.svg');
      background-size: 8px auto;
      padding: 20px;
      background-position: right 32px center;
      background-repeat: no-repeat;
      > .linktitle {
        font-size: 24px;
      }
      > .linktext {
        font-size: 14px;
        color: $dark;
        margin: 0;
      }
    }
  }
}

.contact-box,.cv-box {
  >.card-body {
    @include mq-down(md) {
      @include flex(flex,center,center,column,wrap);
      > .element-box {
        &:first-child {
          margin-bottom: 35px;
        }
      }
    }
    @include mq-up(md) {
      @include flex(flex,space-around,stretch,row,nowrap);
      > .element-box {
        margin: 10px auto;
        &:first-child {
          border-right: 1px solid $secondary;
          padding-right: 20px;
        }
        &:last-child {
          padding-left: 20px;
        }
      }
    }
  }
}
.-image-top {
  .card-body {
    color: $dark;
    padding: 0;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card/CardBody.vue